"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = CheckBoxQuestion;

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _schemaStore = require("../../state/schema-store");

var _languageStore = require("../../state/language-store");

var _schemaReducer = require("../../state/schema-reducer");

var _ArrowUpwardOutlined = _interopRequireDefault(require("@material-ui/icons/ArrowUpwardOutlined"));

var _ArrowDownwardOutlined = _interopRequireDefault(require("@material-ui/icons/ArrowDownwardOutlined"));

var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    addQuestion: {
      border: "dashed ".concat(theme.palette.primary.main, " 1px"),
      color: theme.palette.primary.main,
      padding: "15px 0px"
    }
  };
});

function CheckBoxQuestion(_ref) {
  var _schema$properties$id, _schema$properties$id2, _schema$properties$id3;

  var id = _ref.id;

  var _useContext = (0, _react.useContext)(_schemaStore.SchemaContext),
      _useContext2 = (0, _slicedToArray2.default)(_useContext, 2),
      schema = _useContext2[0],
      schemaDispatch = _useContext2[1];

  var _useContext3 = (0, _react.useContext)(_languageStore.LanguageContext),
      _useContext4 = (0, _slicedToArray2.default)(_useContext3, 1),
      language = _useContext4[0];

  var title = (schema === null || schema === void 0 ? void 0 : (_schema$properties$id = schema.properties[id]) === null || _schema$properties$id === void 0 ? void 0 : _schema$properties$id.title) || "";
  var enums = (schema === null || schema === void 0 ? void 0 : (_schema$properties$id2 = schema.properties[id]) === null || _schema$properties$id2 === void 0 ? void 0 : (_schema$properties$id3 = _schema$properties$id2.items) === null || _schema$properties$id3 === void 0 ? void 0 : _schema$properties$id3.enum) || [];
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
    size: "small",
    fullWidth: true,
    label: "".concat(language.questionnaireInputTitleLabel),
    name: "text",
    type: "text",
    variant: "outlined",
    onChange: function onChange(e) {
      return schemaDispatch({
        type: _schemaReducer.TYPES.UPDATE_QUESTION_TITLE,
        payload: {
          index: id,
          title: e.target.value
        }
      });
    },
    value: title || ""
  })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    spacing: 3
  }, (0, _map.default)(enums).call(enums, function (v, k) {
    return /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      container: true,
      key: k
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 7
    }, /*#__PURE__*/_react.default.createElement(_core.TextField, {
      size: "small",
      fullWidth: true,
      label: "".concat(language.questionnaireInputDescriptionLabel),
      name: "item".concat(k),
      type: "text",
      variant: "outlined",
      value: v || "",
      onChange: function onChange(e) {
        return schemaDispatch({
          type: _schemaReducer.TYPES.UPDATE_CHECKBOX_BUTTON,
          payload: {
            index: id,
            value: e.target.value,
            key: k
          }
        });
      }
    })), /*#__PURE__*/_react.default.createElement(_core.Grid, {
      item: true,
      xs: 4
    }, /*#__PURE__*/_react.default.createElement(_core.Grid, {
      container: true
    }, /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      disabled: k === 0 ? true : false,
      onClick: function onClick() {
        return schemaDispatch({
          type: _schemaReducer.TYPES.UPDATE_CHECKBOX_BUTTON_ORDER,
          payload: {
            index: id,
            direction: _schemaReducer.DIRECTIONS.UP,
            key: k
          }
        });
      }
    }, /*#__PURE__*/_react.default.createElement(_ArrowUpwardOutlined.default, null)), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      disabled: k + 1 >= enums.length ? true : false,
      onClick: function onClick() {
        return schemaDispatch({
          type: _schemaReducer.TYPES.UPDATE_CHECKBOX_BUTTON_ORDER,
          payload: {
            index: id,
            direction: _schemaReducer.DIRECTIONS.DOWN,
            key: k
          }
        });
      }
    }, /*#__PURE__*/_react.default.createElement(_ArrowDownwardOutlined.default, null)), /*#__PURE__*/_react.default.createElement(_core.IconButton, {
      onClick: function onClick() {
        return schemaDispatch({
          type: _schemaReducer.TYPES.DELETE_CHECKBOX_BUTTON,
          payload: {
            index: id,
            key: k
          }
        });
      }
    }, /*#__PURE__*/_react.default.createElement(_Delete.default, {
      color: "primary"
    })))));
  }), /*#__PURE__*/_react.default.createElement(_core.Grid, {
    item: true,
    xs: 12
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    fullWidth: true,
    className: classes.addQuestion,
    onClick: function onClick() {
      return schemaDispatch({
        type: _schemaReducer.TYPES.ADD_CHECKBBOX_BUTTON,
        payload: id
      });
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, null, language.addOptionLabel))))));
}